import React from 'react'

const Cricket = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 25' version='1.1'>
      <title>Cricket</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-734.000000, -629.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-14' transform='translate(693.000000, 605.000000)'>
            <g id='icon/16/sport/cricket/cricket-bat' transform='translate(41.000000, 24.089286)'>
              <path
                d='M23.5519847,5.74910509 L10.7384934,18.7594941 L5.30108981,13.3978204 L18.1751651,0.448015281 C18.4595558,0.161282891 18.8466806,0 19.250529,0 C19.6543774,0 20.0415022,0.161282891 20.3258929,0.448015281 L23.4914008,3.61352319 C24.095734,4.18746642 24.122808,5.14182409 23.5519847,5.74910509 Z M3.86222257,18.3202609 L0,22.1067536 L1.89324636,24 L5.67973908,20.2135073 L9.4662318,19.4562087 L4.54379126,14.5337682 L3.86222257,18.3202609 Z M2.34762549,8.61169359 C3.64856666,9.45141214 5.35916172,9.26922173 6.45405331,8.17433014 C7.5489449,7.07943855 7.7311353,5.3688435 6.89141675,4.06790232 C6.74316629,3.82365338 6.54114199,3.61644897 6.30072389,3.46206349 C4.99829049,2.65841534 3.31431276,2.85510396 2.23214293,3.93727379 C1.14997309,5.01944362 0.953284474,6.70342135 1.75693262,8.00585475 C1.90103968,8.25328368 2.10392353,8.46136968 2.34762549,8.61169359 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Cricket
